export default {
  object: 'terminal.connection_token',
  secret:
    'pst_test_YWNjdF8xSEtveVdIRU9DU3docVFvLEl5RXJnMzlnejFKdll3MnJvWXZMZFJyN0tWRmxjVFc_000CCE0xRc',
};
